<script setup lang="ts">
import { EPrimitive } from '@/types/enum/PrimitivesEnum'
import moment from 'moment'
import { InputField, NumberInputField, ToggleButtonField } from '.'
import DatePickerField from './DatePickerField.vue'

type Props = {
    modelValue?: any
    dataType?: string
    label?: string
}
defineProps<Props>()
defineEmits<{
    (e: 'click', event: MouseEvent): void
    (e: 'change', value: any): void
}>()
</script>

<template>
    <InputField
        v-if="dataType === EPrimitive.STRING || dataType === EPrimitive.ENUM"
        :label="label"
        :modelValue="modelValue"
        @change="$emit('change', $event)"
        v-bind="$attrs" />
    <NumberInputField
        v-else-if="
            dataType === EPrimitive.INTEGER ||
            dataType === EPrimitive.FLOAT ||
            dataType === EPrimitive.NUMBER
        "
        :prefix="$t('unit.number')"
        :label="label"
        :modelValue="modelValue"
        @change="$emit('change', $event)"
        v-bind="$attrs" />
    <ToggleButtonField
        v-else-if="dataType === EPrimitive.BOOLEAN"
        :label="label"
        :modelValue="modelValue"
        @change="$emit('change', $event)"
        v-bind="$attrs" />
    <DatePickerField
        v-else-if="
            dataType === 'Date' || (typeof modelValue === 'object' && moment(modelValue).isValid())
        "
        :label="label"
        :modelValue="modelValue"
        @change="$emit('change', $event)"
        v-bind="$attrs" />
    <TypedInput
        v-else
        v-for="([itemKey, itemValue], key) in Object.entries(modelValue)"
        :dataType="itemValue as string"
        :key="key"
        :modelValue="itemValue"
        :label="itemValue as string"
        :dataKey="itemKey"
        @change="$emit('change', { [itemKey]: $event })"
        v-bind="$attrs" />
</template>
